import { Menu } from 'antd'
import styled from 'styled-components'

const StyledMenu = styled(Menu)`
  flex: auto;
`

export default StyledMenu
